export default {"src":"/_next/static/media/seaweed.62038167.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};